export interface ColorPalette {
  primary100: string
  primary400: string
  primary600: string
  secondary100: string
  secondary400: string
  secondary600: string
  neutral100: string
  neutral300: string
  neutral400: string
  neutral500: string
  neutral600: string
  info30: string
  info100: string
  info400: string
  warning30: string
  warning100: string
  warning400: string
  warningAlt100: string
  success30: string
  success100: string
  success400: string
  accent100: string
  accent400: string
  alert30: string
  alert100: string
  alert400: string
  white: string
  gray20: string
  gray70: string
  gray80: string
  gray90: string
  gray100: string
  gray200: string
  gray300: string
  gray400: string
  gray500: string
  gray600: string
  gray700: string
  gray800: string
  gray900: string
  black: string
  primary: string
  primaryHover: string
  primaryActive: string
  primaryFocus: string
}
